import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type EventLinkedUserDetailFragment = { __typename?: 'EventLinkedUser', id: string, user_name: string, password?: string | null, role?: string | null };

export const EventLinkedUserDetailFragmentDoc = gql`
    fragment EventLinkedUserDetail on EventLinkedUser {
  id
  user_name
  password
  role
}
    `;